import { CallSplit } from "@mui/icons-material";
import React, { memo } from "react";
import { NodeCard, valuePill } from "./commonNode";

const accent = "#9a00ed";

export default memo(({ data, isConnectable, id }) => {
  const firstPercent = Number(data?.percent || 0);
  const secondPercent = 100 - firstPercent;

  return (
    <NodeCard
      id={id}
      title="Randomizador"
      accent={accent}
      icon={<CallSplit sx={{ width: 15, height: 15, color: accent }} />}
      isConnectable={isConnectable}
      targetTop="50%"
      sourceHandles={[
        { id: "a", top: "57%" },
        { id: "b", top: "78%" }
      ]}
    >
      <div style={{ display: "grid", gap: 7 }}>
        <div style={{ ...valuePill(accent), textAlign: "right", fontWeight: 600 }}>
          {firstPercent}%
        </div>
        <div style={{ ...valuePill(accent), textAlign: "right", fontWeight: 600 }}>
          {secondPercent}%
        </div>
      </div>
    </NodeCard>
  );
});
